// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$String = require("rescript/lib/js/string.js");
var Tooltip = require("./Tooltip.bs.js");
var UTCDate = require("./types/UTCDate.bs.js");
var DateFns = require("date-fns");
var Text__Jsx3 = require("../../uikit/reason/helpers/Text__Jsx3.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Colors = require("uikit/styles/colors");

function RelativeDateLabel(props) {
  var date = props.date;
  var __fontSize = props.fontSize;
  var __color = props.color;
  var color = __color !== undefined ? __color : Colors.gray;
  var fontSize = __fontSize !== undefined ? __fontSize : ({
        NAME: "px",
        VAL: 13
      });
  return JsxRuntime.jsx(Tooltip.make, {
              label: DateFns.format(UTCDate.toUnzonedDate(date), "MM/dd/yyyy h:mma"),
              children: JsxRuntime.jsx("span", {
                    children: JsxRuntime.jsx(Text__Jsx3.make, {
                          as_: props.as_,
                          fontSize: fontSize,
                          color: color,
                          lineClamp: props.lineClamp,
                          className: props.className,
                          children: $$String.capitalize_ascii(DateFns.formatDistance(UTCDate.toUnzonedDate(date), new Date()) + " ago")
                        })
                  })
            });
}

var make = RelativeDateLabel;

exports.make = make;
/* Tooltip Not a pure module */
